import { api } from '@/services'
import { formatPrice } from '@/utils'

export async function addInstallmentRequest(
    checkoutId: string,
    paymentMethod: string,
    cartInstallments: number
) {
    try {
        const { data } = await api.post('Cart/SelecionarFormaPagamento', null, {
            params: {
                CheckoutId: checkoutId,
                metodoPagamento: paymentMethod,
                parcelas: cartInstallments
            }
        })
        return { data }
    } catch (error) {
        console.error(error)
    }
}
